import { render, staticRenderFns } from "./PutawayConfiguration.vue?vue&type=template&id=1bb36e93"
import script from "./PutawayConfiguration.vue?vue&type=script&lang=js"
export * from "./PutawayConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports